/**
 * @fileoverview gRPC-Web generated client stub for aviwest.web.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.12.4
// source: aviwest/web/v1/web_v1.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var aviwest_commons_v2_commons_pb = require('../../../aviwest/commons/v2/commons_pb.js')
const proto = {};
proto.aviwest = {};
proto.aviwest.web = {};
proto.aviwest.web.v1 = require('./web_v1_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.SancusServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.SancusServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.aviwest.web.v1.SancusEntity>}
 */
const methodDescriptor_SancusService_getIdentity = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.SancusService/getIdentity',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  proto.aviwest.web.v1.SancusEntity,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.SancusEntity.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.SancusEntity)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.SancusEntity>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.SancusServiceClient.prototype.getIdentity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.SancusService/getIdentity',
      request,
      metadata || {},
      methodDescriptor_SancusService_getIdentity,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.SancusEntity>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.SancusServicePromiseClient.prototype.getIdentity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.SancusService/getIdentity',
      request,
      metadata || {},
      methodDescriptor_SancusService_getIdentity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.aviwest.web.v1.SancusTokens>}
 */
const methodDescriptor_SancusService_refreshHAT = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.SancusService/refreshHAT',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  proto.aviwest.web.v1.SancusTokens,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.SancusTokens.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.SancusTokens)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.SancusTokens>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.SancusServiceClient.prototype.refreshHAT =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.SancusService/refreshHAT',
      request,
      metadata || {},
      methodDescriptor_SancusService_refreshHAT,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.SancusTokens>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.SancusServicePromiseClient.prototype.refreshHAT =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.SancusService/refreshHAT',
      request,
      metadata || {},
      methodDescriptor_SancusService_refreshHAT);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.JellyfishServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.JellyfishServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.AccountNameSearchRequest,
 *   !proto.aviwest.web.v1.JellyfishAccounts>}
 */
const methodDescriptor_JellyfishService_searchAccountsByName = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.JellyfishService/searchAccountsByName',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.AccountNameSearchRequest,
  proto.aviwest.web.v1.JellyfishAccounts,
  /**
   * @param {!proto.aviwest.web.v1.AccountNameSearchRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.JellyfishAccounts.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.AccountNameSearchRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.JellyfishAccounts)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.JellyfishAccounts>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.JellyfishServiceClient.prototype.searchAccountsByName =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.JellyfishService/searchAccountsByName',
      request,
      metadata || {},
      methodDescriptor_JellyfishService_searchAccountsByName,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.AccountNameSearchRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.JellyfishAccounts>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.JellyfishServicePromiseClient.prototype.searchAccountsByName =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.JellyfishService/searchAccountsByName',
      request,
      metadata || {},
      methodDescriptor_JellyfishService_searchAccountsByName);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.AccountServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.AccountServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.Account,
 *   !proto.aviwest.web.v1.Account>}
 */
const methodDescriptor_AccountService_create = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountService/create',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.Account,
  proto.aviwest.web.v1.Account,
  /**
   * @param {!proto.aviwest.web.v1.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Account.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Account)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Account>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountServiceClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/create',
      request,
      metadata || {},
      methodDescriptor_AccountService_create,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Account>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountServicePromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/create',
      request,
      metadata || {},
      methodDescriptor_AccountService_create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.aviwest.web.v1.Account>}
 */
const methodDescriptor_AccountService_updateFromJellyfish = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountService/updateFromJellyfish',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  proto.aviwest.web.v1.Account,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Account.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Account)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Account>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountServiceClient.prototype.updateFromJellyfish =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/updateFromJellyfish',
      request,
      metadata || {},
      methodDescriptor_AccountService_updateFromJellyfish,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Account>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountServicePromiseClient.prototype.updateFromJellyfish =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/updateFromJellyfish',
      request,
      metadata || {},
      methodDescriptor_AccountService_updateFromJellyfish);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.aviwest.web.v1.Account>}
 */
const methodDescriptor_AccountService_get = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountService/get',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  proto.aviwest.web.v1.Account,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Account.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Account)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Account>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountServiceClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/get',
      request,
      metadata || {},
      methodDescriptor_AccountService_get,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Account>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountServicePromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/get',
      request,
      metadata || {},
      methodDescriptor_AccountService_get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.commons.v2.RequestFilter,
 *   !proto.aviwest.web.v1.AccountNames>}
 */
const methodDescriptor_AccountService_getAllNames = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountService/getAllNames',
  grpc.web.MethodType.UNARY,
  aviwest_commons_v2_commons_pb.RequestFilter,
  proto.aviwest.web.v1.AccountNames,
  /**
   * @param {!proto.aviwest.commons.v2.RequestFilter} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.AccountNames.deserializeBinary
);


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.AccountNames)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.AccountNames>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountServiceClient.prototype.getAllNames =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/getAllNames',
      request,
      metadata || {},
      methodDescriptor_AccountService_getAllNames,
      callback);
};


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.AccountNames>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountServicePromiseClient.prototype.getAllNames =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/getAllNames',
      request,
      metadata || {},
      methodDescriptor_AccountService_getAllNames);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.commons.v2.RequestFilter,
 *   !proto.aviwest.web.v1.Accounts>}
 */
const methodDescriptor_AccountService_getAll = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountService/getAll',
  grpc.web.MethodType.UNARY,
  aviwest_commons_v2_commons_pb.RequestFilter,
  proto.aviwest.web.v1.Accounts,
  /**
   * @param {!proto.aviwest.commons.v2.RequestFilter} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Accounts.deserializeBinary
);


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Accounts)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Accounts>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountServiceClient.prototype.getAll =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/getAll',
      request,
      metadata || {},
      methodDescriptor_AccountService_getAll,
      callback);
};


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Accounts>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountServicePromiseClient.prototype.getAll =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/getAll',
      request,
      metadata || {},
      methodDescriptor_AccountService_getAll);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.google.protobuf.StringValue>}
 */
const methodDescriptor_AccountService_getDownloadKeyUri = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountService/getDownloadKeyUri',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  google_protobuf_wrappers_pb.StringValue,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_wrappers_pb.StringValue.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.StringValue)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.StringValue>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountServiceClient.prototype.getDownloadKeyUri =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/getDownloadKeyUri',
      request,
      metadata || {},
      methodDescriptor_AccountService_getDownloadKeyUri,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.StringValue>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountServicePromiseClient.prototype.getDownloadKeyUri =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/getDownloadKeyUri',
      request,
      metadata || {},
      methodDescriptor_AccountService_getDownloadKeyUri);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AccountService_revokeKey = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountService/revokeKey',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountServiceClient.prototype.revokeKey =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/revokeKey',
      request,
      metadata || {},
      methodDescriptor_AccountService_revokeKey,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountServicePromiseClient.prototype.revokeKey =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/revokeKey',
      request,
      metadata || {},
      methodDescriptor_AccountService_revokeKey);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.Account,
 *   !proto.aviwest.web.v1.Account>}
 */
const methodDescriptor_AccountService_update = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountService/update',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.Account,
  proto.aviwest.web.v1.Account,
  /**
   * @param {!proto.aviwest.web.v1.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Account.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Account)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Account>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/update',
      request,
      metadata || {},
      methodDescriptor_AccountService_update,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Account>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/update',
      request,
      metadata || {},
      methodDescriptor_AccountService_update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.Account,
 *   !proto.aviwest.web.v1.Account>}
 */
const methodDescriptor_AccountService_linkWithJellyfishAccount = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountService/linkWithJellyfishAccount',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.Account,
  proto.aviwest.web.v1.Account,
  /**
   * @param {!proto.aviwest.web.v1.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Account.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Account)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Account>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountServiceClient.prototype.linkWithJellyfishAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/linkWithJellyfishAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_linkWithJellyfishAccount,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Account>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountServicePromiseClient.prototype.linkWithJellyfishAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/linkWithJellyfishAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_linkWithJellyfishAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.SubscriptionsForm,
 *   !proto.aviwest.web.v1.Subscriptions>}
 */
const methodDescriptor_AccountService_getSubscriptionsFor = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountService/getSubscriptionsFor',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.SubscriptionsForm,
  proto.aviwest.web.v1.Subscriptions,
  /**
   * @param {!proto.aviwest.web.v1.SubscriptionsForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Subscriptions.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.SubscriptionsForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Subscriptions)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Subscriptions>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountServiceClient.prototype.getSubscriptionsFor =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/getSubscriptionsFor',
      request,
      metadata || {},
      methodDescriptor_AccountService_getSubscriptionsFor,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.SubscriptionsForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Subscriptions>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountServicePromiseClient.prototype.getSubscriptionsFor =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountService/getSubscriptionsFor',
      request,
      metadata || {},
      methodDescriptor_AccountService_getSubscriptionsFor);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.ProductServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.ProductServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.Product,
 *   !proto.aviwest.web.v1.Product>}
 */
const methodDescriptor_ProductService_create = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.ProductService/create',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.Product,
  proto.aviwest.web.v1.Product,
  /**
   * @param {!proto.aviwest.web.v1.Product} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Product.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.Product} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Product)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Product>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.ProductServiceClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/create',
      request,
      metadata || {},
      methodDescriptor_ProductService_create,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.Product} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Product>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.ProductServicePromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/create',
      request,
      metadata || {},
      methodDescriptor_ProductService_create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.Product,
 *   !proto.aviwest.web.v1.Product>}
 */
const methodDescriptor_ProductService_update = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.ProductService/update',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.Product,
  proto.aviwest.web.v1.Product,
  /**
   * @param {!proto.aviwest.web.v1.Product} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Product.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.Product} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Product)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Product>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.ProductServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/update',
      request,
      metadata || {},
      methodDescriptor_ProductService_update,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.Product} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Product>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.ProductServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/update',
      request,
      metadata || {},
      methodDescriptor_ProductService_update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.SellRentForm,
 *   !proto.aviwest.web.v1.Product>}
 */
const methodDescriptor_ProductService_setUserShipFor = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.ProductService/setUserShipFor',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.SellRentForm,
  proto.aviwest.web.v1.Product,
  /**
   * @param {!proto.aviwest.web.v1.SellRentForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Product.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.SellRentForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Product)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Product>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.ProductServiceClient.prototype.setUserShipFor =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/setUserShipFor',
      request,
      metadata || {},
      methodDescriptor_ProductService_setUserShipFor,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.SellRentForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Product>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.ProductServicePromiseClient.prototype.setUserShipFor =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/setUserShipFor',
      request,
      metadata || {},
      methodDescriptor_ProductService_setUserShipFor);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.SellRentForm,
 *   !proto.aviwest.web.v1.Product>}
 */
const methodDescriptor_ProductService_setOwnerShipFor = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.ProductService/setOwnerShipFor',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.SellRentForm,
  proto.aviwest.web.v1.Product,
  /**
   * @param {!proto.aviwest.web.v1.SellRentForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Product.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.SellRentForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Product)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Product>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.ProductServiceClient.prototype.setOwnerShipFor =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/setOwnerShipFor',
      request,
      metadata || {},
      methodDescriptor_ProductService_setOwnerShipFor,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.SellRentForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Product>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.ProductServicePromiseClient.prototype.setOwnerShipFor =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/setOwnerShipFor',
      request,
      metadata || {},
      methodDescriptor_ProductService_setOwnerShipFor);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.aviwest.web.v1.Product>}
 */
const methodDescriptor_ProductService_get = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.ProductService/get',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  proto.aviwest.web.v1.Product,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Product.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Product)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Product>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.ProductServiceClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/get',
      request,
      metadata || {},
      methodDescriptor_ProductService_get,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Product>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.ProductServicePromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/get',
      request,
      metadata || {},
      methodDescriptor_ProductService_get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.commons.v2.RequestFilter,
 *   !proto.aviwest.web.v1.Products>}
 */
const methodDescriptor_ProductService_getAll = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.ProductService/getAll',
  grpc.web.MethodType.UNARY,
  aviwest_commons_v2_commons_pb.RequestFilter,
  proto.aviwest.web.v1.Products,
  /**
   * @param {!proto.aviwest.commons.v2.RequestFilter} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Products.deserializeBinary
);


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Products)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Products>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.ProductServiceClient.prototype.getAll =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/getAll',
      request,
      metadata || {},
      methodDescriptor_ProductService_getAll,
      callback);
};


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Products>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.ProductServicePromiseClient.prototype.getAll =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/getAll',
      request,
      metadata || {},
      methodDescriptor_ProductService_getAll);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.UploadLegacyReq,
 *   !proto.aviwest.web.v1.UploadLegacyRes>}
 */
const methodDescriptor_ProductService_uploadLegacy = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.ProductService/uploadLegacy',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.UploadLegacyReq,
  proto.aviwest.web.v1.UploadLegacyRes,
  /**
   * @param {!proto.aviwest.web.v1.UploadLegacyReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.UploadLegacyRes.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.UploadLegacyReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.UploadLegacyRes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.UploadLegacyRes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.ProductServiceClient.prototype.uploadLegacy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/uploadLegacy',
      request,
      metadata || {},
      methodDescriptor_ProductService_uploadLegacy,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.UploadLegacyReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.UploadLegacyRes>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.ProductServicePromiseClient.prototype.uploadLegacy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/uploadLegacy',
      request,
      metadata || {},
      methodDescriptor_ProductService_uploadLegacy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.DownloadUriForm,
 *   !proto.google.protobuf.StringValue>}
 */
const methodDescriptor_ProductService_getDownloadUri = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.ProductService/getDownloadUri',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.DownloadUriForm,
  google_protobuf_wrappers_pb.StringValue,
  /**
   * @param {!proto.aviwest.web.v1.DownloadUriForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_wrappers_pb.StringValue.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.DownloadUriForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.StringValue)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.StringValue>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.ProductServiceClient.prototype.getDownloadUri =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/getDownloadUri',
      request,
      metadata || {},
      methodDescriptor_ProductService_getDownloadUri,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.DownloadUriForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.StringValue>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.ProductServicePromiseClient.prototype.getDownloadUri =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/getDownloadUri',
      request,
      metadata || {},
      methodDescriptor_ProductService_getDownloadUri);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.aviwest.web.v1.AccountProductsStatistics>}
 */
const methodDescriptor_ProductService_getStatsByAccountId = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.ProductService/getStatsByAccountId',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  proto.aviwest.web.v1.AccountProductsStatistics,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.AccountProductsStatistics.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.AccountProductsStatistics)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.AccountProductsStatistics>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.ProductServiceClient.prototype.getStatsByAccountId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/getStatsByAccountId',
      request,
      metadata || {},
      methodDescriptor_ProductService_getStatsByAccountId,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.AccountProductsStatistics>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.ProductServicePromiseClient.prototype.getStatsByAccountId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/getStatsByAccountId',
      request,
      metadata || {},
      methodDescriptor_ProductService_getStatsByAccountId);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.GroupReceiversPriority,
 *   !proto.aviwest.web.v1.GroupReceiversPriority>}
 */
const methodDescriptor_ProductService_setReceiversPriorityForGroupUuid = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.ProductService/setReceiversPriorityForGroupUuid',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.GroupReceiversPriority,
  proto.aviwest.web.v1.GroupReceiversPriority,
  /**
   * @param {!proto.aviwest.web.v1.GroupReceiversPriority} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.GroupReceiversPriority.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.GroupReceiversPriority} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.GroupReceiversPriority)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.GroupReceiversPriority>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.ProductServiceClient.prototype.setReceiversPriorityForGroupUuid =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/setReceiversPriorityForGroupUuid',
      request,
      metadata || {},
      methodDescriptor_ProductService_setReceiversPriorityForGroupUuid,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.GroupReceiversPriority} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.GroupReceiversPriority>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.ProductServicePromiseClient.prototype.setReceiversPriorityForGroupUuid =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/setReceiversPriorityForGroupUuid',
      request,
      metadata || {},
      methodDescriptor_ProductService_setReceiversPriorityForGroupUuid);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.aviwest.web.v1.GroupReceiversPriority>}
 */
const methodDescriptor_ProductService_getReceiversPriorityByGroupUuid = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.ProductService/getReceiversPriorityByGroupUuid',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  proto.aviwest.web.v1.GroupReceiversPriority,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.GroupReceiversPriority.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.GroupReceiversPriority)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.GroupReceiversPriority>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.ProductServiceClient.prototype.getReceiversPriorityByGroupUuid =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/getReceiversPriorityByGroupUuid',
      request,
      metadata || {},
      methodDescriptor_ProductService_getReceiversPriorityByGroupUuid,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.GroupReceiversPriority>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.ProductServicePromiseClient.prototype.getReceiversPriorityByGroupUuid =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.ProductService/getReceiversPriorityByGroupUuid',
      request,
      metadata || {},
      methodDescriptor_ProductService_getReceiversPriorityByGroupUuid);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.LiveGuestServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.aviwest.web.v1.LiveGuestNotificationMessage>}
 */
const methodDescriptor_LiveGuestService_subscribe = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/subscribe',
  grpc.web.MethodType.SERVER_STREAMING,
  google_protobuf_wrappers_pb.StringValue,
  proto.aviwest.web.v1.LiveGuestNotificationMessage,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.LiveGuestNotificationMessage.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.LiveGuestNotificationMessage>}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/subscribe',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_subscribe);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.LiveGuestNotificationMessage>}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/subscribe',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_subscribe);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveGuestService_unsubscribe = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/unsubscribe',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.unsubscribe =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/unsubscribe',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_unsubscribe,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.unsubscribe =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/unsubscribe',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_unsubscribe);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.LiveGuestAuthenticationForm,
 *   !proto.aviwest.web.v1.LiveGuestAuthenticationResponse>}
 */
const methodDescriptor_LiveGuestService_authenticate = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/authenticate',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.LiveGuestAuthenticationForm,
  proto.aviwest.web.v1.LiveGuestAuthenticationResponse,
  /**
   * @param {!proto.aviwest.web.v1.LiveGuestAuthenticationForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.LiveGuestAuthenticationResponse.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.LiveGuestAuthenticationForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.LiveGuestAuthenticationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.LiveGuestAuthenticationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.authenticate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/authenticate',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_authenticate,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.LiveGuestAuthenticationForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.LiveGuestAuthenticationResponse>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.authenticate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/authenticate',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_authenticate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.aviwest.web.v1.IceServerConfiguration>}
 */
const methodDescriptor_LiveGuestService_getIceServers = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/getIceServers',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  proto.aviwest.web.v1.IceServerConfiguration,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.IceServerConfiguration.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.IceServerConfiguration)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.IceServerConfiguration>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.getIceServers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/getIceServers',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_getIceServers,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.IceServerConfiguration>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.getIceServers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/getIceServers',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_getIceServers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.IceConnectionInfo,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveGuestService_sendIceConnectionInfo = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/sendIceConnectionInfo',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.IceConnectionInfo,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.IceConnectionInfo} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.IceConnectionInfo} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.sendIceConnectionInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/sendIceConnectionInfo',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_sendIceConnectionInfo,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.IceConnectionInfo} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.sendIceConnectionInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/sendIceConnectionInfo',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_sendIceConnectionInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.AddIceCandidateForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveGuestService_addIceCandidate = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/addIceCandidate',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.AddIceCandidateForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.AddIceCandidateForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.AddIceCandidateForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.addIceCandidate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/addIceCandidate',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_addIceCandidate,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.AddIceCandidateForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.addIceCandidate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/addIceCandidate',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_addIceCandidate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.Call,
 *   !proto.aviwest.web.v1.Call>}
 */
const methodDescriptor_LiveGuestService_tempcreateOrUpdateLiveGuest = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/tempcreateOrUpdateLiveGuest',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.Call,
  proto.aviwest.web.v1.Call,
  /**
   * @param {!proto.aviwest.web.v1.Call} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Call.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.Call} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Call)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Call>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.tempcreateOrUpdateLiveGuest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/tempcreateOrUpdateLiveGuest',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_tempcreateOrUpdateLiveGuest,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.Call} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Call>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.tempcreateOrUpdateLiveGuest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/tempcreateOrUpdateLiveGuest',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_tempcreateOrUpdateLiveGuest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.aviwest.web.v1.Call>}
 */
const methodDescriptor_LiveGuestService_getByIdentifier = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/getByIdentifier',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  proto.aviwest.web.v1.Call,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Call.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Call)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Call>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.getByIdentifier =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/getByIdentifier',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_getByIdentifier,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Call>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.getByIdentifier =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/getByIdentifier',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_getByIdentifier);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.LiveGuestActionForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveGuestService_prepare = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/prepare',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.LiveGuestActionForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.LiveGuestActionForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.LiveGuestActionForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.prepare =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/prepare',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_prepare,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.LiveGuestActionForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.prepare =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/prepare',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_prepare);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveGuestService_join = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/join',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.join =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/join',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_join,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.join =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/join',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_join);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.LiveGuestActionForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveGuestService_negotiate = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/negotiate',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.LiveGuestActionForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.LiveGuestActionForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.LiveGuestActionForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.negotiate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/negotiate',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_negotiate,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.LiveGuestActionForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.negotiate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/negotiate',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_negotiate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveGuestService_negotiateVideoReturn = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/negotiateVideoReturn',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.negotiateVideoReturn =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/negotiateVideoReturn',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_negotiateVideoReturn,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.negotiateVideoReturn =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/negotiateVideoReturn',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_negotiateVideoReturn);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveGuestService_negotiateIntercom = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/negotiateIntercom',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.negotiateIntercom =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/negotiateIntercom',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_negotiateIntercom,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.negotiateIntercom =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/negotiateIntercom',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_negotiateIntercom);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.LiveGuestActionForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveGuestService_videoReturnReady = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/videoReturnReady',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.LiveGuestActionForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.LiveGuestActionForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.LiveGuestActionForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.videoReturnReady =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/videoReturnReady',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_videoReturnReady,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.LiveGuestActionForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.videoReturnReady =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/videoReturnReady',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_videoReturnReady);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.LiveGuestActionForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveGuestService_intercomReady = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/intercomReady',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.LiveGuestActionForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.LiveGuestActionForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.LiveGuestActionForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.intercomReady =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/intercomReady',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_intercomReady,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.LiveGuestActionForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.intercomReady =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/intercomReady',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_intercomReady);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveGuestService_leave = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveGuestService/leave',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveGuestServiceClient.prototype.leave =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/leave',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_leave,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveGuestServicePromiseClient.prototype.leave =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveGuestService/leave',
      request,
      metadata || {},
      methodDescriptor_LiveGuestService_leave);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.ConsumptionServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.ConsumptionServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.aviwest.web.v1.ConsumptionGlobalInfo>}
 */
const methodDescriptor_ConsumptionService_getInfoForAccount = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.ConsumptionService/getInfoForAccount',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  proto.aviwest.web.v1.ConsumptionGlobalInfo,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.ConsumptionGlobalInfo.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.ConsumptionGlobalInfo)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.ConsumptionGlobalInfo>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.ConsumptionServiceClient.prototype.getInfoForAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.ConsumptionService/getInfoForAccount',
      request,
      metadata || {},
      methodDescriptor_ConsumptionService_getInfoForAccount,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.ConsumptionGlobalInfo>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.ConsumptionServicePromiseClient.prototype.getInfoForAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.ConsumptionService/getInfoForAccount',
      request,
      metadata || {},
      methodDescriptor_ConsumptionService_getInfoForAccount);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.OptionServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.OptionServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.OptionSet,
 *   !proto.aviwest.web.v1.OptionSet>}
 */
const methodDescriptor_OptionService_updateSet = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.OptionService/updateSet',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.OptionSet,
  proto.aviwest.web.v1.OptionSet,
  /**
   * @param {!proto.aviwest.web.v1.OptionSet} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.OptionSet.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.OptionSet} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.OptionSet)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.OptionSet>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.OptionServiceClient.prototype.updateSet =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.OptionService/updateSet',
      request,
      metadata || {},
      methodDescriptor_OptionService_updateSet,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.OptionSet} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.OptionSet>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.OptionServicePromiseClient.prototype.updateSet =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.OptionService/updateSet',
      request,
      metadata || {},
      methodDescriptor_OptionService_updateSet);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.aviwest.web.v1.Options>}
 */
const methodDescriptor_OptionService_getAllByProductId = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.OptionService/getAllByProductId',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  proto.aviwest.web.v1.Options,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Options.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Options)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Options>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.OptionServiceClient.prototype.getAllByProductId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.OptionService/getAllByProductId',
      request,
      metadata || {},
      methodDescriptor_OptionService_getAllByProductId,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Options>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.OptionServicePromiseClient.prototype.getAllByProductId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.OptionService/getAllByProductId',
      request,
      metadata || {},
      methodDescriptor_OptionService_getAllByProductId);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.PAYGOptionConfClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.PAYGOptionConfPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.aviwest.web.v1.PAYGOptions>}
 */
const methodDescriptor_PAYGOptionConf_getAllByAccountId = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.PAYGOptionConf/getAllByAccountId',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  proto.aviwest.web.v1.PAYGOptions,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.PAYGOptions.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.PAYGOptions)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.PAYGOptions>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.PAYGOptionConfClient.prototype.getAllByAccountId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.PAYGOptionConf/getAllByAccountId',
      request,
      metadata || {},
      methodDescriptor_PAYGOptionConf_getAllByAccountId,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.PAYGOptions>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.PAYGOptionConfPromiseClient.prototype.getAllByAccountId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.PAYGOptionConf/getAllByAccountId',
      request,
      metadata || {},
      methodDescriptor_PAYGOptionConf_getAllByAccountId);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.PAYGOptions,
 *   !proto.aviwest.web.v1.PAYGOptions>}
 */
const methodDescriptor_PAYGOptionConf_updateSet = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.PAYGOptionConf/updateSet',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.PAYGOptions,
  proto.aviwest.web.v1.PAYGOptions,
  /**
   * @param {!proto.aviwest.web.v1.PAYGOptions} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.PAYGOptions.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.PAYGOptions} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.PAYGOptions)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.PAYGOptions>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.PAYGOptionConfClient.prototype.updateSet =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.PAYGOptionConf/updateSet',
      request,
      metadata || {},
      methodDescriptor_PAYGOptionConf_updateSet,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.PAYGOptions} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.PAYGOptions>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.PAYGOptionConfPromiseClient.prototype.updateSet =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.PAYGOptionConf/updateSet',
      request,
      metadata || {},
      methodDescriptor_PAYGOptionConf_updateSet);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.AccountOptionConfClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.AccountOptionConfPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.aviwest.web.v1.AccountOptions>}
 */
const methodDescriptor_AccountOptionConf_getAllByAccountId = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountOptionConf/getAllByAccountId',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  proto.aviwest.web.v1.AccountOptions,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.AccountOptions.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.AccountOptions)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.AccountOptions>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountOptionConfClient.prototype.getAllByAccountId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountOptionConf/getAllByAccountId',
      request,
      metadata || {},
      methodDescriptor_AccountOptionConf_getAllByAccountId,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.AccountOptions>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountOptionConfPromiseClient.prototype.getAllByAccountId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountOptionConf/getAllByAccountId',
      request,
      metadata || {},
      methodDescriptor_AccountOptionConf_getAllByAccountId);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.AccountOptionSet,
 *   !proto.aviwest.web.v1.AccountOptions>}
 */
const methodDescriptor_AccountOptionConf_updateSet = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountOptionConf/updateSet',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.AccountOptionSet,
  proto.aviwest.web.v1.AccountOptions,
  /**
   * @param {!proto.aviwest.web.v1.AccountOptionSet} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.AccountOptions.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.AccountOptionSet} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.AccountOptions)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.AccountOptions>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountOptionConfClient.prototype.updateSet =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountOptionConf/updateSet',
      request,
      metadata || {},
      methodDescriptor_AccountOptionConf_updateSet,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.AccountOptionSet} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.AccountOptions>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountOptionConfPromiseClient.prototype.updateSet =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountOptionConf/updateSet',
      request,
      metadata || {},
      methodDescriptor_AccountOptionConf_updateSet);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.NotificationServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.NotificationServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.NotificationFilters,
 *   !proto.aviwest.web.v1.NotificationMessage>}
 */
const methodDescriptor_NotificationService_subscribe = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.NotificationService/subscribe',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.aviwest.web.v1.NotificationFilters,
  proto.aviwest.web.v1.NotificationMessage,
  /**
   * @param {!proto.aviwest.web.v1.NotificationFilters} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.NotificationMessage.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.NotificationFilters} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.NotificationMessage>}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.NotificationServiceClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/aviwest.web.v1.NotificationService/subscribe',
      request,
      metadata || {},
      methodDescriptor_NotificationService_subscribe);
};


/**
 * @param {!proto.aviwest.web.v1.NotificationFilters} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.NotificationMessage>}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.NotificationServicePromiseClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/aviwest.web.v1.NotificationService/subscribe',
      request,
      metadata || {},
      methodDescriptor_NotificationService_subscribe);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.NotificationFilters,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_NotificationService_setFilters = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.NotificationService/setFilters',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.NotificationFilters,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.NotificationFilters} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.NotificationFilters} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.NotificationServiceClient.prototype.setFilters =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.NotificationService/setFilters',
      request,
      metadata || {},
      methodDescriptor_NotificationService_setFilters,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.NotificationFilters} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.NotificationServicePromiseClient.prototype.setFilters =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.NotificationService/setFilters',
      request,
      metadata || {},
      methodDescriptor_NotificationService_setFilters);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.ActionServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.ActionServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.commons.v2.RequestFilter,
 *   !proto.aviwest.web.v1.Actions>}
 */
const methodDescriptor_ActionService_getAll = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.ActionService/getAll',
  grpc.web.MethodType.UNARY,
  aviwest_commons_v2_commons_pb.RequestFilter,
  proto.aviwest.web.v1.Actions,
  /**
   * @param {!proto.aviwest.commons.v2.RequestFilter} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Actions.deserializeBinary
);


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Actions)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Actions>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.ActionServiceClient.prototype.getAll =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.ActionService/getAll',
      request,
      metadata || {},
      methodDescriptor_ActionService_getAll,
      callback);
};


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Actions>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.ActionServicePromiseClient.prototype.getAll =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.ActionService/getAll',
      request,
      metadata || {},
      methodDescriptor_ActionService_getAll);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.AccountDockerOptionServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.AccountDockerOptionServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.aviwest.web.v1.AccountDockerOption>}
 */
const methodDescriptor_AccountDockerOptionService_getBy = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountDockerOptionService/getBy',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  proto.aviwest.web.v1.AccountDockerOption,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.AccountDockerOption.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.AccountDockerOption)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.AccountDockerOption>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountDockerOptionServiceClient.prototype.getBy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountDockerOptionService/getBy',
      request,
      metadata || {},
      methodDescriptor_AccountDockerOptionService_getBy,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.AccountDockerOption>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountDockerOptionServicePromiseClient.prototype.getBy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountDockerOptionService/getBy',
      request,
      metadata || {},
      methodDescriptor_AccountDockerOptionService_getBy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.aviwest.web.v1.AccountDockerOptions>}
 */
const methodDescriptor_AccountDockerOptionService_getAll = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.AccountDockerOptionService/getAll',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.aviwest.web.v1.AccountDockerOptions,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.AccountDockerOptions.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.AccountDockerOptions)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.AccountDockerOptions>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.AccountDockerOptionServiceClient.prototype.getAll =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.AccountDockerOptionService/getAll',
      request,
      metadata || {},
      methodDescriptor_AccountDockerOptionService_getAll,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.AccountDockerOptions>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.AccountDockerOptionServicePromiseClient.prototype.getAll =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.AccountDockerOptionService/getAll',
      request,
      metadata || {},
      methodDescriptor_AccountDockerOptionService_getAll);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.FieldUnitServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.FieldUnitServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.aviwest.web.v1.FieldUnit>}
 */
const methodDescriptor_FieldUnitService_get = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.FieldUnitService/get',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  proto.aviwest.web.v1.FieldUnit,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.FieldUnit.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.FieldUnit)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.FieldUnit>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.FieldUnitServiceClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.FieldUnitService/get',
      request,
      metadata || {},
      methodDescriptor_FieldUnitService_get,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.FieldUnit>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.FieldUnitServicePromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.FieldUnitService/get',
      request,
      metadata || {},
      methodDescriptor_FieldUnitService_get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.commons.v2.RequestFilter,
 *   !proto.aviwest.web.v1.FieldUnits>}
 */
const methodDescriptor_FieldUnitService_getAll = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.FieldUnitService/getAll',
  grpc.web.MethodType.UNARY,
  aviwest_commons_v2_commons_pb.RequestFilter,
  proto.aviwest.web.v1.FieldUnits,
  /**
   * @param {!proto.aviwest.commons.v2.RequestFilter} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.FieldUnits.deserializeBinary
);


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.FieldUnits)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.FieldUnits>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.FieldUnitServiceClient.prototype.getAll =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.FieldUnitService/getAll',
      request,
      metadata || {},
      methodDescriptor_FieldUnitService_getAll,
      callback);
};


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.FieldUnits>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.FieldUnitServicePromiseClient.prototype.getAll =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.FieldUnitService/getAll',
      request,
      metadata || {},
      methodDescriptor_FieldUnitService_getAll);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.aviwest.web.v1.FieldUnit>}
 */
const methodDescriptor_FieldUnitService_getByHwId = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.FieldUnitService/getByHwId',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  proto.aviwest.web.v1.FieldUnit,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.FieldUnit.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.FieldUnit)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.FieldUnit>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.FieldUnitServiceClient.prototype.getByHwId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.FieldUnitService/getByHwId',
      request,
      metadata || {},
      methodDescriptor_FieldUnitService_getByHwId,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.FieldUnit>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.FieldUnitServicePromiseClient.prototype.getByHwId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.FieldUnitService/getByHwId',
      request,
      metadata || {},
      methodDescriptor_FieldUnitService_getByHwId);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.FieldUnit,
 *   !proto.aviwest.web.v1.FieldUnit>}
 */
const methodDescriptor_FieldUnitService_update = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.FieldUnitService/update',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.FieldUnit,
  proto.aviwest.web.v1.FieldUnit,
  /**
   * @param {!proto.aviwest.web.v1.FieldUnit} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.FieldUnit.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.FieldUnit} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.FieldUnit)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.FieldUnit>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.FieldUnitServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.FieldUnitService/update',
      request,
      metadata || {},
      methodDescriptor_FieldUnitService_update,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.FieldUnit} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.FieldUnit>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.FieldUnitServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.FieldUnitService/update',
      request,
      metadata || {},
      methodDescriptor_FieldUnitService_update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_FieldUnitService_delete = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.FieldUnitService/delete',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.FieldUnitServiceClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.FieldUnitService/delete',
      request,
      metadata || {},
      methodDescriptor_FieldUnitService_delete,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.FieldUnitServicePromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.FieldUnitService/delete',
      request,
      metadata || {},
      methodDescriptor_FieldUnitService_delete);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.LiveServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.LiveServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.LiveForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_createUsingFU = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/createUsingFU',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.LiveForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.LiveForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.LiveForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.createUsingFU =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/createUsingFU',
      request,
      metadata || {},
      methodDescriptor_LiveService_createUsingFU,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.LiveForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.createUsingFU =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/createUsingFU',
      request,
      metadata || {},
      methodDescriptor_LiveService_createUsingFU);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.LiveForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_stopForFU = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/stopForFU',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.LiveForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.LiveForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.LiveForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.stopForFU =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/stopForFU',
      request,
      metadata || {},
      methodDescriptor_LiveService_stopForFU,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.LiveForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.stopForFU =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/stopForFU',
      request,
      metadata || {},
      methodDescriptor_LiveService_stopForFU);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.LiveForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_disconnectForFU = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/disconnectForFU',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.LiveForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.LiveForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.LiveForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.disconnectForFU =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/disconnectForFU',
      request,
      metadata || {},
      methodDescriptor_LiveService_disconnectForFU,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.LiveForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.disconnectForFU =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/disconnectForFU',
      request,
      metadata || {},
      methodDescriptor_LiveService_disconnectForFU);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.LiveForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_startLive = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/startLive',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.LiveForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.LiveForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.LiveForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.startLive =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/startLive',
      request,
      metadata || {},
      methodDescriptor_LiveService_startLive,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.LiveForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.startLive =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/startLive',
      request,
      metadata || {},
      methodDescriptor_LiveService_startLive);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.LiveForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_stopLive = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/stopLive',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.LiveForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.LiveForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.LiveForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.stopLive =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/stopLive',
      request,
      metadata || {},
      methodDescriptor_LiveService_stopLive,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.LiveForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.stopLive =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/stopLive',
      request,
      metadata || {},
      methodDescriptor_LiveService_stopLive);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.LiveForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_disconnectSource = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/disconnectSource',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.LiveForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.LiveForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.LiveForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.disconnectSource =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/disconnectSource',
      request,
      metadata || {},
      methodDescriptor_LiveService_disconnectSource,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.LiveForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.disconnectSource =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/disconnectSource',
      request,
      metadata || {},
      methodDescriptor_LiveService_disconnectSource);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.MakitoConfigurationForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_configureMakito = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/configureMakito',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.MakitoConfigurationForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.MakitoConfigurationForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.MakitoConfigurationForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.configureMakito =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/configureMakito',
      request,
      metadata || {},
      methodDescriptor_LiveService_configureMakito,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.MakitoConfigurationForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.configureMakito =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/configureMakito',
      request,
      metadata || {},
      methodDescriptor_LiveService_configureMakito);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.LatencyForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_setLatency = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/setLatency',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.LatencyForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.LatencyForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.LatencyForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.setLatency =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/setLatency',
      request,
      metadata || {},
      methodDescriptor_LiveService_setLatency,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.LatencyForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.setLatency =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/setLatency',
      request,
      metadata || {},
      methodDescriptor_LiveService_setLatency);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.BitrateForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_setVideoCappedBitrate = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/setVideoCappedBitrate',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.BitrateForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.BitrateForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.BitrateForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.setVideoCappedBitrate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/setVideoCappedBitrate',
      request,
      metadata || {},
      methodDescriptor_LiveService_setVideoCappedBitrate,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.BitrateForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.setVideoCappedBitrate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/setVideoCappedBitrate',
      request,
      metadata || {},
      methodDescriptor_LiveService_setVideoCappedBitrate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.aviwest.web.v1.LiveNotificationMessage>}
 */
const methodDescriptor_LiveService_subscribe = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/subscribe',
  grpc.web.MethodType.SERVER_STREAMING,
  google_protobuf_wrappers_pb.UInt64Value,
  proto.aviwest.web.v1.LiveNotificationMessage,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.LiveNotificationMessage.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.LiveNotificationMessage>}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/aviwest.web.v1.LiveService/subscribe',
      request,
      metadata || {},
      methodDescriptor_LiveService_subscribe);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.LiveNotificationMessage>}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.subscribe =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/aviwest.web.v1.LiveService/subscribe',
      request,
      metadata || {},
      methodDescriptor_LiveService_subscribe);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_unsubscribe = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/unsubscribe',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.unsubscribe =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/unsubscribe',
      request,
      metadata || {},
      methodDescriptor_LiveService_unsubscribe,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.unsubscribe =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/unsubscribe',
      request,
      metadata || {},
      methodDescriptor_LiveService_unsubscribe);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.LiveNotificationFilters,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_setFilters = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/setFilters',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.LiveNotificationFilters,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.LiveNotificationFilters} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.LiveNotificationFilters} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.setFilters =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/setFilters',
      request,
      metadata || {},
      methodDescriptor_LiveService_setFilters,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.LiveNotificationFilters} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.setFilters =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/setFilters',
      request,
      metadata || {},
      methodDescriptor_LiveService_setFilters);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.NotificationEcho,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_ackEcho = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/ackEcho',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.NotificationEcho,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.NotificationEcho} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.NotificationEcho} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.ackEcho =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/ackEcho',
      request,
      metadata || {},
      methodDescriptor_LiveService_ackEcho,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.NotificationEcho} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.ackEcho =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/ackEcho',
      request,
      metadata || {},
      methodDescriptor_LiveService_ackEcho);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.RouteUpdateForm,
 *   !proto.aviwest.web.v1.Route>}
 */
const methodDescriptor_LiveService_createOrUpdateRoute = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/createOrUpdateRoute',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.RouteUpdateForm,
  proto.aviwest.web.v1.Route,
  /**
   * @param {!proto.aviwest.web.v1.RouteUpdateForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Route.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.RouteUpdateForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Route)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Route>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.createOrUpdateRoute =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/createOrUpdateRoute',
      request,
      metadata || {},
      methodDescriptor_LiveService_createOrUpdateRoute,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.RouteUpdateForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Route>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.createOrUpdateRoute =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/createOrUpdateRoute',
      request,
      metadata || {},
      methodDescriptor_LiveService_createOrUpdateRoute);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.RouteUpdateForm,
 *   !proto.aviwest.web.v1.Route>}
 */
const methodDescriptor_LiveService_enableDisableRoute = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/enableDisableRoute',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.RouteUpdateForm,
  proto.aviwest.web.v1.Route,
  /**
   * @param {!proto.aviwest.web.v1.RouteUpdateForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Route.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.RouteUpdateForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Route)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Route>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.enableDisableRoute =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/enableDisableRoute',
      request,
      metadata || {},
      methodDescriptor_LiveService_enableDisableRoute,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.RouteUpdateForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Route>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.enableDisableRoute =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/enableDisableRoute',
      request,
      metadata || {},
      methodDescriptor_LiveService_enableDisableRoute);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.GetRoutesByHwIdForm,
 *   !proto.aviwest.web.v1.Routes>}
 */
const methodDescriptor_LiveService_getAllRoutesByHwId = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/getAllRoutesByHwId',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.GetRoutesByHwIdForm,
  proto.aviwest.web.v1.Routes,
  /**
   * @param {!proto.aviwest.web.v1.GetRoutesByHwIdForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Routes.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.GetRoutesByHwIdForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Routes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Routes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.getAllRoutesByHwId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/getAllRoutesByHwId',
      request,
      metadata || {},
      methodDescriptor_LiveService_getAllRoutesByHwId,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.GetRoutesByHwIdForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Routes>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.getAllRoutesByHwId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/getAllRoutesByHwId',
      request,
      metadata || {},
      methodDescriptor_LiveService_getAllRoutesByHwId);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.StreamhubList,
 *   !proto.aviwest.web.v1.AllRoutes>}
 */
const methodDescriptor_LiveService_getAllRoutes = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/getAllRoutes',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.StreamhubList,
  proto.aviwest.web.v1.AllRoutes,
  /**
   * @param {!proto.aviwest.web.v1.StreamhubList} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.AllRoutes.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.StreamhubList} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.AllRoutes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.AllRoutes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.getAllRoutes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/getAllRoutes',
      request,
      metadata || {},
      methodDescriptor_LiveService_getAllRoutes,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.StreamhubList} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.AllRoutes>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.getAllRoutes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/getAllRoutes',
      request,
      metadata || {},
      methodDescriptor_LiveService_getAllRoutes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.BookForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_book = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/book',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.BookForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.BookForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.BookForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.book =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/book',
      request,
      metadata || {},
      methodDescriptor_LiveService_book,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.BookForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.book =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/book',
      request,
      metadata || {},
      methodDescriptor_LiveService_book);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.ShInputForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_startShIntercom = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/startShIntercom',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.ShInputForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.ShInputForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.ShInputForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.startShIntercom =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/startShIntercom',
      request,
      metadata || {},
      methodDescriptor_LiveService_startShIntercom,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.ShInputForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.startShIntercom =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/startShIntercom',
      request,
      metadata || {},
      methodDescriptor_LiveService_startShIntercom);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.ShInputForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_stopShIntercom = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/stopShIntercom',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.ShInputForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.ShInputForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.ShInputForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.stopShIntercom =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/stopShIntercom',
      request,
      metadata || {},
      methodDescriptor_LiveService_stopShIntercom,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.ShInputForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.stopShIntercom =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/stopShIntercom',
      request,
      metadata || {},
      methodDescriptor_LiveService_stopShIntercom);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.ShInputForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_startShRecording = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/startShRecording',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.ShInputForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.ShInputForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.ShInputForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.startShRecording =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/startShRecording',
      request,
      metadata || {},
      methodDescriptor_LiveService_startShRecording,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.ShInputForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.startShRecording =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/startShRecording',
      request,
      metadata || {},
      methodDescriptor_LiveService_startShRecording);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.ShInputForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LiveService_stopShRecording = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.LiveService/stopShRecording',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.ShInputForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.ShInputForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.ShInputForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.LiveServiceClient.prototype.stopShRecording =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/stopShRecording',
      request,
      metadata || {},
      methodDescriptor_LiveService_stopShRecording,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.ShInputForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.LiveServicePromiseClient.prototype.stopShRecording =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.LiveService/stopShRecording',
      request,
      metadata || {},
      methodDescriptor_LiveService_stopShRecording);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.BookingServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.BookingServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.aviwest.web.v1.Booking>}
 */
const methodDescriptor_BookingService_get = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.BookingService/get',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  proto.aviwest.web.v1.Booking,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Booking.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Booking)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Booking>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.BookingServiceClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.BookingService/get',
      request,
      metadata || {},
      methodDescriptor_BookingService_get,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Booking>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.BookingServicePromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.BookingService/get',
      request,
      metadata || {},
      methodDescriptor_BookingService_get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.commons.v2.RequestFilter,
 *   !proto.aviwest.web.v1.Bookings>}
 */
const methodDescriptor_BookingService_getAll = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.BookingService/getAll',
  grpc.web.MethodType.UNARY,
  aviwest_commons_v2_commons_pb.RequestFilter,
  proto.aviwest.web.v1.Bookings,
  /**
   * @param {!proto.aviwest.commons.v2.RequestFilter} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Bookings.deserializeBinary
);


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Bookings)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Bookings>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.BookingServiceClient.prototype.getAll =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.BookingService/getAll',
      request,
      metadata || {},
      methodDescriptor_BookingService_getAll,
      callback);
};


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Bookings>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.BookingServicePromiseClient.prototype.getAll =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.BookingService/getAll',
      request,
      metadata || {},
      methodDescriptor_BookingService_getAll);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.Booking,
 *   !proto.aviwest.web.v1.Booking>}
 */
const methodDescriptor_BookingService_createOrUpdate = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.BookingService/createOrUpdate',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.Booking,
  proto.aviwest.web.v1.Booking,
  /**
   * @param {!proto.aviwest.web.v1.Booking} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Booking.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.Booking} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Booking)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Booking>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.BookingServiceClient.prototype.createOrUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.BookingService/createOrUpdate',
      request,
      metadata || {},
      methodDescriptor_BookingService_createOrUpdate,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.Booking} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Booking>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.BookingServicePromiseClient.prototype.createOrUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.BookingService/createOrUpdate',
      request,
      metadata || {},
      methodDescriptor_BookingService_createOrUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_BookingService_delete = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.BookingService/delete',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.BookingServiceClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.BookingService/delete',
      request,
      metadata || {},
      methodDescriptor_BookingService_delete,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.BookingServicePromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.BookingService/delete',
      request,
      metadata || {},
      methodDescriptor_BookingService_delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.StreamhubInputRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_BookingService_deleteAllForStreamhubInput = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.BookingService/deleteAllForStreamhubInput',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.StreamhubInputRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.StreamhubInputRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.StreamhubInputRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.BookingServiceClient.prototype.deleteAllForStreamhubInput =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.BookingService/deleteAllForStreamhubInput',
      request,
      metadata || {},
      methodDescriptor_BookingService_deleteAllForStreamhubInput,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.StreamhubInputRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.BookingServicePromiseClient.prototype.deleteAllForStreamhubInput =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.BookingService/deleteAllForStreamhubInput',
      request,
      metadata || {},
      methodDescriptor_BookingService_deleteAllForStreamhubInput);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.CloudProductServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.CloudProductServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.CloudProductCreationForm,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_CloudProductService_create = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.CloudProductService/create',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.CloudProductCreationForm,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.CloudProductCreationForm} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.CloudProductCreationForm} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.CloudProductServiceClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/create',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_create,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.CloudProductCreationForm} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.CloudProductServicePromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/create',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.CloudProduct,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_CloudProductService_update = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.CloudProductService/update',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.CloudProduct,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.CloudProduct} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.CloudProduct} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.CloudProductServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/update',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_update,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.CloudProduct} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.CloudProductServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/update',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.aviwest.web.v1.CloudProduct>}
 */
const methodDescriptor_CloudProductService_get = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.CloudProductService/get',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  proto.aviwest.web.v1.CloudProduct,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.CloudProduct.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.CloudProduct)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.CloudProduct>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.CloudProductServiceClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/get',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_get,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.CloudProduct>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.CloudProductServicePromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/get',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.CloudProduct,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_CloudProductService_pause = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.CloudProductService/pause',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.CloudProduct,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.CloudProduct} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.CloudProduct} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.CloudProductServiceClient.prototype.pause =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/pause',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_pause,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.CloudProduct} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.CloudProductServicePromiseClient.prototype.pause =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/pause',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_pause);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.CloudProduct,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_CloudProductService_resume = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.CloudProductService/resume',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.CloudProduct,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.CloudProduct} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.CloudProduct} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.CloudProductServiceClient.prototype.resume =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/resume',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_resume,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.CloudProduct} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.CloudProductServicePromiseClient.prototype.resume =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/resume',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_resume);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.CloudProduct,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_CloudProductService_delete = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.CloudProductService/delete',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.CloudProduct,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.aviwest.web.v1.CloudProduct} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.CloudProduct} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.CloudProductServiceClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/delete',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_delete,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.CloudProduct} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.CloudProductServicePromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/delete',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.commons.v2.RequestFilter,
 *   !proto.aviwest.web.v1.CloudProducts>}
 */
const methodDescriptor_CloudProductService_getAll = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.CloudProductService/getAll',
  grpc.web.MethodType.UNARY,
  aviwest_commons_v2_commons_pb.RequestFilter,
  proto.aviwest.web.v1.CloudProducts,
  /**
   * @param {!proto.aviwest.commons.v2.RequestFilter} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.CloudProducts.deserializeBinary
);


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.CloudProducts)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.CloudProducts>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.CloudProductServiceClient.prototype.getAll =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/getAll',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_getAll,
      callback);
};


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.CloudProducts>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.CloudProductServicePromiseClient.prototype.getAll =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/getAll',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_getAll);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.aviwest.web.v1.Versions>}
 */
const methodDescriptor_CloudProductService_getAvailableVersions = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.CloudProductService/getAvailableVersions',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.aviwest.web.v1.Versions,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Versions.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Versions)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Versions>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.CloudProductServiceClient.prototype.getAvailableVersions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/getAvailableVersions',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_getAvailableVersions,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Versions>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.CloudProductServicePromiseClient.prototype.getAvailableVersions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.CloudProductService/getAvailableVersions',
      request,
      metadata || {},
      methodDescriptor_CloudProductService_getAvailableVersions);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.RegistrationCodeServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.RegistrationCodeServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.RegistrationCode,
 *   !proto.aviwest.web.v1.RegistrationCode>}
 */
const methodDescriptor_RegistrationCodeService_createOrUpdate = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.RegistrationCodeService/createOrUpdate',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.RegistrationCode,
  proto.aviwest.web.v1.RegistrationCode,
  /**
   * @param {!proto.aviwest.web.v1.RegistrationCode} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.RegistrationCode.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.RegistrationCode} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.RegistrationCode)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.RegistrationCode>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.RegistrationCodeServiceClient.prototype.createOrUpdate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.RegistrationCodeService/createOrUpdate',
      request,
      metadata || {},
      methodDescriptor_RegistrationCodeService_createOrUpdate,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.RegistrationCode} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.RegistrationCode>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.RegistrationCodeServicePromiseClient.prototype.createOrUpdate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.RegistrationCodeService/createOrUpdate',
      request,
      metadata || {},
      methodDescriptor_RegistrationCodeService_createOrUpdate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.aviwest.web.v1.RegistrationCode>}
 */
const methodDescriptor_RegistrationCodeService_get = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.RegistrationCodeService/get',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  proto.aviwest.web.v1.RegistrationCode,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.RegistrationCode.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.RegistrationCode)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.RegistrationCode>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.RegistrationCodeServiceClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.RegistrationCodeService/get',
      request,
      metadata || {},
      methodDescriptor_RegistrationCodeService_get,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.RegistrationCode>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.RegistrationCodeServicePromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.RegistrationCodeService/get',
      request,
      metadata || {},
      methodDescriptor_RegistrationCodeService_get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.StringValue,
 *   !proto.aviwest.web.v1.RegistrationCode>}
 */
const methodDescriptor_RegistrationCodeService_getByCode = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.RegistrationCodeService/getByCode',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.StringValue,
  proto.aviwest.web.v1.RegistrationCode,
  /**
   * @param {!proto.google.protobuf.StringValue} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.RegistrationCode.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.RegistrationCode)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.RegistrationCode>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.RegistrationCodeServiceClient.prototype.getByCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.RegistrationCodeService/getByCode',
      request,
      metadata || {},
      methodDescriptor_RegistrationCodeService_getByCode,
      callback);
};


/**
 * @param {!proto.google.protobuf.StringValue} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.RegistrationCode>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.RegistrationCodeServicePromiseClient.prototype.getByCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.RegistrationCodeService/getByCode',
      request,
      metadata || {},
      methodDescriptor_RegistrationCodeService_getByCode);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.commons.v2.RequestFilter,
 *   !proto.aviwest.web.v1.RegistrationCodes>}
 */
const methodDescriptor_RegistrationCodeService_getAll = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.RegistrationCodeService/getAll',
  grpc.web.MethodType.UNARY,
  aviwest_commons_v2_commons_pb.RequestFilter,
  proto.aviwest.web.v1.RegistrationCodes,
  /**
   * @param {!proto.aviwest.commons.v2.RequestFilter} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.RegistrationCodes.deserializeBinary
);


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.RegistrationCodes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.RegistrationCodes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.RegistrationCodeServiceClient.prototype.getAll =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.RegistrationCodeService/getAll',
      request,
      metadata || {},
      methodDescriptor_RegistrationCodeService_getAll,
      callback);
};


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.RegistrationCodes>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.RegistrationCodeServicePromiseClient.prototype.getAll =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.RegistrationCodeService/getAll',
      request,
      metadata || {},
      methodDescriptor_RegistrationCodeService_getAll);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.UInt64Value,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RegistrationCodeService_delete = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.RegistrationCodeService/delete',
  grpc.web.MethodType.UNARY,
  google_protobuf_wrappers_pb.UInt64Value,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.UInt64Value} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.RegistrationCodeServiceClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.RegistrationCodeService/delete',
      request,
      metadata || {},
      methodDescriptor_RegistrationCodeService_delete,
      callback);
};


/**
 * @param {!proto.google.protobuf.UInt64Value} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.RegistrationCodeServicePromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.RegistrationCodeService/delete',
      request,
      metadata || {},
      methodDescriptor_RegistrationCodeService_delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.RequestFieldUnits,
 *   !proto.aviwest.web.v1.FieldUnits>}
 */
const methodDescriptor_RegistrationCodeService_getFieldUnits = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.RegistrationCodeService/getFieldUnits',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.RequestFieldUnits,
  proto.aviwest.web.v1.FieldUnits,
  /**
   * @param {!proto.aviwest.web.v1.RequestFieldUnits} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.FieldUnits.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.RequestFieldUnits} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.FieldUnits)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.FieldUnits>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.RegistrationCodeServiceClient.prototype.getFieldUnits =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.RegistrationCodeService/getFieldUnits',
      request,
      metadata || {},
      methodDescriptor_RegistrationCodeService_getFieldUnits,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.RequestFieldUnits} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.FieldUnits>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.RegistrationCodeServicePromiseClient.prototype.getFieldUnits =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.RegistrationCodeService/getFieldUnits',
      request,
      metadata || {},
      methodDescriptor_RegistrationCodeService_getFieldUnits);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.DeviceServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.aviwest.web.v1.DeviceServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.web.v1.DeviceId,
 *   !proto.aviwest.web.v1.Device>}
 */
const methodDescriptor_DeviceService_get = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.DeviceService/get',
  grpc.web.MethodType.UNARY,
  proto.aviwest.web.v1.DeviceId,
  proto.aviwest.web.v1.Device,
  /**
   * @param {!proto.aviwest.web.v1.DeviceId} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Device.deserializeBinary
);


/**
 * @param {!proto.aviwest.web.v1.DeviceId} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Device)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Device>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.DeviceServiceClient.prototype.get =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.DeviceService/get',
      request,
      metadata || {},
      methodDescriptor_DeviceService_get,
      callback);
};


/**
 * @param {!proto.aviwest.web.v1.DeviceId} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Device>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.DeviceServicePromiseClient.prototype.get =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.DeviceService/get',
      request,
      metadata || {},
      methodDescriptor_DeviceService_get);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.aviwest.commons.v2.RequestFilter,
 *   !proto.aviwest.web.v1.Devices>}
 */
const methodDescriptor_DeviceService_getAll = new grpc.web.MethodDescriptor(
  '/aviwest.web.v1.DeviceService/getAll',
  grpc.web.MethodType.UNARY,
  aviwest_commons_v2_commons_pb.RequestFilter,
  proto.aviwest.web.v1.Devices,
  /**
   * @param {!proto.aviwest.commons.v2.RequestFilter} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.aviwest.web.v1.Devices.deserializeBinary
);


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.aviwest.web.v1.Devices)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.aviwest.web.v1.Devices>|undefined}
 *     The XHR Node Readable Stream
 */
proto.aviwest.web.v1.DeviceServiceClient.prototype.getAll =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/aviwest.web.v1.DeviceService/getAll',
      request,
      metadata || {},
      methodDescriptor_DeviceService_getAll,
      callback);
};


/**
 * @param {!proto.aviwest.commons.v2.RequestFilter} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.aviwest.web.v1.Devices>}
 *     Promise that resolves to the response
 */
proto.aviwest.web.v1.DeviceServicePromiseClient.prototype.getAll =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/aviwest.web.v1.DeviceService/getAll',
      request,
      metadata || {},
      methodDescriptor_DeviceService_getAll);
};


module.exports = proto.aviwest.web.v1;

